module.exports = __webpack_public_path__ + "static/img/basic02.e33f61d2.jpg";